import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';

import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import {
  PrimaryButton,
  H1ForgotPassword,
  H2ForgotPassword,
  InputBlack
} from '../../components/HelperComponents/StyledComponents';

import {
  BulmaHero
} from '../../components/HelperComponents/HelperComponents';

import BackgroundImage from '../../images/background.png';

import {
  forgotPassword
} from '../../actions/UserActions';

// Our inner form component which receives our form's state and updater methods as props
const InnerForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
}) => (
  <form onSubmit={handleSubmit}>
    <H1ForgotPassword className="has-text-centered has-text-white is-uppercase">Forgot Password</H1ForgotPassword>
    <H2ForgotPassword className="has-text-centered has-text-white">Let us help you!</H2ForgotPassword>
    <div className="field">
      <div className="control" >
        <InputBlack
          className="input is-transparent is-rounded has-background-dark"
          placeholder="Email"
          type="email"
          name="user_login"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.user_login}
        />
          {touched.user_login && errors.user_login && <p className="help is-danger">{errors.user_login}</p>}
      </div>
    </div>

    <PrimaryButton className="button is-rounded" style={{ width: '100%' }} type="submit" disabled={isSubmitting}>
      Submit
    </PrimaryButton>
  </form>
);

InnerForm.propTypes = {
  values: PropTypes.any,
  errors: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
  touched: PropTypes.any,
  isSubmitting: PropTypes.any
};

export class ForgotPasswordComponent extends Component {
  static propTypes = {
    dispatch: PropTypes.func
  }

  render() {
    // Wrap our form with the using withFormik HoC
    const MyForm = withFormik({
      // Transform outer props into form values
      mapPropsToValues: _props => ({ user_login: '' }),
      validationSchema: Yup.object({
        user_login: Yup.string().required('Email is required')
      }),
      // Submission handler
      handleSubmit: (
        values,
        {
          _props,
          _setSubmitting,
          _setErrors /* setValues, setStatus, and other goodies */,
        }
      ) => {
        this.props.dispatch(forgotPassword(values, this.props.history));
      },
    })(InnerForm);

    const FormStructure = () => (
      <section className="container">
        <section className="columns is-centered">
          <section className="column is-4">
            <MyForm />
          </section>
        </section>
      </section>
    );

    return (
      <Fragment>
        <BulmaHero heroSize="is-fullheight" activateBodyPadding={true} body={<FormStructure />} image={BackgroundImage}></BulmaHero>
      </Fragment>
    );
  }
}

export const ForgotPassword = connect()(ForgotPasswordComponent);


// WEBPACK FOOTER //
// ./src/routes/ForgotPassword/ForgotPassword.js